import {decodeBrowserLossless} from './browserLossless';

/** One decode in flight. BrowserRuntime retains only the newest waiting packet. */
export class BrowserLosslessWorker {
  available = true;
  private worker: Worker | null = null;
  private pending: {resolve:(pixels:Uint8ClampedArray<ArrayBuffer>)=>void;reject:(error:Error)=>void}|null=null;
  decode(payload:Uint8Array,size:number):Promise<Uint8ClampedArray<ArrayBuffer>> {
    if(!this.available)return Promise.reject(new Error('Browser worker unavailable'));
    if(this.pending)return Promise.reject(new Error('Browser decode already pending'));
    if(typeof Worker==='undefined')return Promise.resolve().then(()=>decodeBrowserLossless(payload,size));
    if(!this.worker){
      try {this.worker=new Worker(new URL('./browserLossless.worker.ts',import.meta.url),{type:'module'});}
      catch {this.available=false;return Promise.reject(new Error('Browser worker unavailable'));}
      this.worker.onmessage=({data}:MessageEvent<{pixels?:Uint8ClampedArray<ArrayBuffer>;error?:boolean}>)=>{
        const pending=this.pending;this.pending=null;
        if(data.pixels instanceof Uint8ClampedArray)pending?.resolve(data.pixels);
        else pending?.reject(new Error('Invalid lossless Browser block'));
      };
      this.worker.onerror=()=>{this.available=false;this.dispose();};
    }
    return new Promise((resolve,reject)=>{
      this.pending={resolve,reject};
      try {this.worker!.postMessage({payload,size},[payload.buffer as ArrayBuffer]);}
      catch {this.dispose();}
    });
  }
  dispose():void {
    if(this.worker){this.worker.onmessage=this.worker.onerror=null;this.worker.terminate();this.worker=null;}
    const pending=this.pending;this.pending=null;
    pending?.reject(new Error('Browser decode canceled'));
  }
}
